export default function EstimateLineItem({label, content, total}) {
    return (
        <div className={"lg:flex lg:items-center lg:justify-between py-[16px] text-[16px] leading-[24px] lg:text-[18px] lg:leading-[28px] border-b border-b-inactive-grey last:border-b-0"}>
            <div className={total ? 'font-bold' : 'font-bold lg:font-normal'}>
                {label}
            </div>
            <div className={`lg:text-right ${total ? 'text-brand-orange font-bold' : 'lg:font-bold'}`}>
                {content}
            </div>
        </div>
    )
}
